document.addEventListener('DOMContentLoaded', function() {
  const videoContainers = document.querySelectorAll('.ec-product-video');
  
  videoContainers.forEach(function(container) {
    const wrapper = container.querySelector('.ec-product-video-wrapper');
    const video = wrapper ? wrapper.querySelector('.ec-product-video-element') : null;
    const playButton = wrapper ? wrapper.querySelector('.ec-product-video-play') : null;
    const blockId = container.getAttribute('data-block-id');
    
    if (!video || !playButton || !blockId) return;
    
    const modal = document.querySelector('.ec-product-video-modal[data-block-id="' + blockId + '"]');
    
    if (!modal || !modal.classList.contains('ec-product-video-modal')) return;
    
    const modalVideo = modal.querySelector('.ec-product-video-modal-element');
    const modalClose = modal.querySelector('.ec-product-video-modal-close');
    const modalOverlay = modal.querySelector('.ec-product-video-modal-overlay');
    
    if (!modalVideo || !modalClose) return;
    
    function openModal() {
      modal.classList.add('ec-modal-active');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        if (modalVideo) {
          modalVideo.play();
        }
      }, 100);
    }
    
    function closeModal() {
      modal.classList.remove('ec-modal-active');
      document.body.style.overflow = '';
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
      }
    }
    
    playButton.addEventListener('click', function(e) {
      e.stopPropagation();
      openModal();
    });
    
    video.addEventListener('click', function() {
      openModal();
    });
    
    modalClose.addEventListener('click', function(e) {
      e.stopPropagation();
      closeModal();
    });
    
    if (modalOverlay) {
      modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) {
          closeModal();
        }
      });
    }
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('ec-modal-active')) {
        closeModal();
      }
    });
    
    video.addEventListener('play', function() {
      wrapper.classList.add('ec-video-playing');
    });
    
    video.addEventListener('pause', function() {
      wrapper.classList.remove('ec-video-playing');
    });
    
    video.addEventListener('ended', function() {
      wrapper.classList.remove('ec-video-playing');
    });
  });
});
